import { API_TYPE, fetchData } from '@umu/umu-fetch';

export function updUserAiSubtitleSetupService(params: {[key:string]:any}){
    return fetchData(
        {
        type: API_TYPE.POST,
        url: '	/uapi/v1/session/upd-user-ai-subtitle-setup',
     }, params, { silent: true }).then((res: any)=>{
        return res.data;
     });
}